import React, { Fragment, Suspense } from "react";
import { metaTag } from "../Library/commomLib";
import { Helmet } from "react-helmet";
import Preloader from "../Components/Common/Preloader";
const ProgressComponent = React.lazy(() => import("../Components/RootComponents/ProgressComponent"));
const ProgressPage = () => {
  return (
    <Fragment>
      <Suspense fallback={<Preloader />}>
        <Helmet>
          <title>{metaTag}</title>
          <meta name={metaTag} content={metaTag} />
        </Helmet>
        <ProgressComponent />
      </Suspense>
    </Fragment>
  );
};

export default ProgressPage;
